import { apiService } from './api';

export interface AppNotification {
  id: string;
  type: string;
  subject: string;
  message: string;
  isRead: boolean;
  link?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  createdAt: string;
}

export interface NotificationListResponse {
  success: boolean;
  data: {
    notifications: AppNotification[];
    unreadCount: number;
  };
}

export interface NotificationCountResponse {
  success: boolean;
  data: { unreadCount: number };
}

class NotificationService {
  private baseUrl = '/notifications';

  list(params: { limit?: number; unreadOnly?: boolean } = {}): Promise<NotificationListResponse> {
    const qs = new URLSearchParams();
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.unreadOnly) qs.set('unreadOnly', 'true');
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return apiService.get(`${this.baseUrl}${suffix}`);
  }

  count(): Promise<NotificationCountResponse> {
    return apiService.get(`${this.baseUrl}/count`);
  }

  markRead(id: string): Promise<{ success: boolean }> {
    return apiService.post(`${this.baseUrl}/${id}/read`);
  }

  markAllRead(): Promise<{ success: boolean }> {
    return apiService.post(`${this.baseUrl}/read-all`);
  }
}

export const notificationService = new NotificationService();
